module.exports = __webpack_public_path__ + "static/media/card-header-public.9364548e.png";